/* eslint-disable max-len */
export const osnNextIcon = {
  data: `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M37.807 5.99731C38.8012 5.99731 39.6072 6.80326 39.6072 7.79745V40.1998C39.6072 41.194 38.8012 42 37.807 42C36.8128 42 36.0069 41.194 36.0069 40.1998V25.7106L10.877 40.1509L8.63564 41.4388L8.62967 38.8538L8.56205 9.57353L8.55615 7.01946L10.7896 8.25834L36.0069 22.246V7.79745C36.0069 6.80326 36.8128 5.99731 37.807 5.99731ZM11.6237 36.2618L11.5679 12.1207L32.9732 23.9938L11.6237 36.2618Z" fill="currentColor"/>
  </svg>
  `,
  name: 'next',
};
